import { getParamFromUrl } from '@fff-web/fff-utilities';
import { ANNUAL_PLAN_CODE, PLAN_CODE, SEASONAL_PLAN_CODE } from './constants';

const getDefaultPlanCode = () => {
  if (getParamFromUrl(PLAN_CODE) === ANNUAL_PLAN_CODE) return ANNUAL_PLAN_CODE;
  return SEASONAL_PLAN_CODE;
};

export { getDefaultPlanCode };
